import tellko_logo from '../images/tellko_logo.png';

export default function PageHeader() {
    return(
        <div className="container-fluid pb-3 fixed-bottom" style={{backgroundColor: '#eeeeee'}}>
          <div className="container pt-3" style={{borderTop: '1px solid #999999'}}>
            <div className="row">
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex flex-wrap align-content-center">
                 <p className='mb-0 copy_right'>© 2025. All rights reserved.</p>
              </div>

              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-end">
                 <p className='mt-0 mb-0' style={{color: '#000000', fontSize: '12px'}}>Powered By &nbsp;<img src={tellko_logo} alt='' className='d-inline-block' style={{ width: '80px' }}></img></p>
              </div>
            </div>
          </div>
        </div>
    );
};
